import Order from "./cPM/Order"
import checkoutDisplay from "./cPM/checkoutDisplay"
import userHandler from "./cPM/userHandling"
import {dbg, find, findAll, getDeviceType, decycle} from "../functions"
import classWatcher from "./cPM/classWatcher/classWatcher"
import ValidateStep1 from "./cPM/validateStep/validateStep1"
import ValidateStep2 from "./cPM/validateStep/validateStep2"
import ValidateStep3 from "./cPM/validateStep/validateStep3"
import Swal from "sweetalert2"

let activeElem = -1,
    _radios = [".rbg-0", ".rbg-1", ".rbg-2", ".rbg-3"],
    _selectID = "sfg1",
    _omnCountryID = "omn_country",
    _omnID = "omn",
    _noteID = "note",
    _genderID = "sfg2",
    _dateID = "sfg3",
    _adressID = "aadress",
    _msgID = "msg",
    _userdata = ".user-data",
    _changeMailLinkSlug = "/mail-aendern",
    _newArticleText = "Sichern und weiteren Artikel hinzufügen",
    _aadressText = "Bitte tragen Sie hier die neue Abholadresse ein:",
    _checkedClass = "cpm-check",
    _finalDataField,
    _finalDataHumanReadable,
    _elems,
    _btn1,
    _btn2,
    _btn3,
    _agbTxt,
    _omn,
    _omnC,
    _date,
    _submitButton,
    _aAdress,
    _checkoutButton,
    debugging = true

export default class customPowermail {
    constructor() {
        this.validationOnStep1 = true
        this.validationOnStep2 = true
        this.validationOnStep3 = true

        this.step1Valid = false
        this.step2Valid = false
        this.step3Valid = false

        /* Step-Validation */
        ;(this.vStep1 = undefined), (this.vStep2 = undefined)
        this.vStep3 = undefined

        this.FormClassOrID = ".tx-powermail.custom-design"
        this.submitButton = find(this.FormClassOrID + " input[type='submit']")
        this.step1Button = document.querySelector("#powermail_field_datenschutz_01_1")
        this.step2Button = document.querySelector(".powermail_form .pull-right[data-powermail-morestep-show='2']")
        this.step3Button = document.querySelector(".powermail_form .pull-right[data-powermail-morestep-show='3']")
        this.radioClasses = [
            ".powermail_fieldwrap_rbg1",
            ".powermail_fieldwrap_rbg2",
            ".powermail_fieldwrap_rbg3",
            ".powermail_fieldwrap_rbg4",
        ]
        this.radioClassAdds = _radios
        this.categoryCheckoutButtonClass = this.FormClassOrID + " .btn-group .btn[data-powermail-morestep-show='2']"
        this.hideClass = "hidden"
        this.articleCategory = undefined
        this.articleRadio = false
        this.orderStarted = false
        this.deviceType = getDeviceType()
        this.orderArray = []
        this.activeOrder = undefined
        this.finalData = undefined
        this.finalDataString = ""

        /* constant init */
        this.prefillUserData()
        this.prefillConstants()

        /* init user and checkoutDisplay */
        this.user = new userHandler(_userdata, this)
        this.checkout = new checkoutDisplay(this)

        if (find(this.FormClassOrID)) {
            // add artSelectButtons and stop construct on empty
            this.rbgElems = this.getAllArticleRadios(this.radioClasses)
            this.artSelectButtons = findAll(".powermail_fieldwrap_article_select .radio")
            if (!this.artSelectButtons) {
                return //dbg(" --- ", "missing article Button definitions! stopped runnning..", " --- ")
            }
            this.addButtons(this.artSelectButtons, this)
            this.resetAllArticleInputs() // reset input content on load
            // this.clearNewAdressField();
            this.registerRbgEvents(this)
            this.hideAllArticleControls()
            this.addChangeMailButton()
            // this.checkNewAdress();

            this.setOmnMandatories()
            this.setOmnEvents()
            this.setArtBtnClassWatcher()
            this.setAadressText(_aadressText)
            this.setAadressTextLink()
            this.setRZALink()

            if (_checkoutButton) {
                this.listenForEventOnCheckoutButton(this)
            }

            //check if order got some items
            if (this.orderArray.length >= 1) {
                // dbg("orderArray got some ", this.orderArray, this.orderArray.length);
                this.enableSubmit()
                this.disableContinue()
            } else {
                this.disableSubmit()
                this.disableContinue()
                // dbg("orderArray empty ", this.orderArray, this.orderArray.length);
            }

            this.validationOnStep1
                ? (this.vStep1 = new ValidateStep1(this, this.user, this.step1Button))
                : /* console.debug("no validation on step 1") */ ""

            this.validationOnStep2
                ? (this.vStep2 = new ValidateStep2(this, this.user, this.step2Button))
                : /* console.debug("no validation on step 2") */ ""
            this.validationOnStep3
                ? (this.vStep3 = new ValidateStep3(this, this.user, this.step3Button))
                : /* console.debug("no validation on step 3") */ ""

            // set readonly for some user data inputs
            this.setUserdataReadonly()

            // register customPowermail object to window
            window.customPowermail = this
            return true
        } else {
            return false
        }
    }

    /**
     * import and add constant data
     */
    prefillConstants() {
        ;(_elems = [
            find("#powermail_field_aad_company"),
            find("#powermail_field_aad_firstname"),
            find("#powermail_field_aad_lastname"),
            find("#powermail_field_aad_tel"),
            find("#powermail_field_aad_street"),
            find("#powermail_field_aad_zip"),
            find("#powermail_field_aad_city"),
        ]),
            (_submitButton = find(".powermail_fieldwrap_type_submit input[type='submit']")),
            (_btn1 = find(".btn-group .btn-default:nth-child(1)")),
            (_btn2 = find(".btn-group .btn-default:nth-child(2)")),
            (_btn3 = find(".btn-group .btn-default:nth-child(3)")),
            (_omn = find("#powermail_field_omn")),
            (_omnC = find("#powermail_field_omn_country")),
            (_date = find("#powermail_field_" + _dateID)),
            (_agbTxt = find(".powermail_fieldwrap_agb label")),
            (_aAdress = find("#powermail_field_" + _adressID)),
            (_finalDataField = find("#powermail_field_a_data")),
            (_finalDataHumanReadable = find("#powermail_field_a_data_hr")),
            (_checkoutButton = find(".powermail_tab_navigation .btn-primary[data-powermail-morestep-show='2']"))
    }

    /**
     * prefills the user data in the form
     */
    prefillUserData() {
        try {
            let userID1 = document.querySelector(".custom-design #powermail_field_username")
            let userID2 = document.getElementById("user-id").dataset.username
            userID1.value = userID2
        } catch (e) {
            console.error("no user-id found in customPowermail constructor: ", e)
        }
    }

    /**
     * add button logic
     * @param {[]} btnsArray - array of button elems
     * @param {customPowermail} _t customPowermail object
     * @returns true if done (boolean)
     */
    addButtons(btnsArray, _t) {
        var iteration = 0
        btnsArray.forEach((btn) => {
            // redeclaration/definition for run purposes, dont ask..
            var iter = iteration
            if (_t.deviceType == "desktop") {
                btn.addEventListener("click", function (e) {
                    _t.handleArticleButtonEvent(e, iter)
                })
            } else if (_t.deviceType == "mobile" || _t.deviceType == "tablet") {
                btn.addEventListener("touchend", function (e) {
                    _t.handleArticleButtonEvent(e, iter)
                })
            }
            ++iteration
        })
        return true
    }

    handleArticleButtonEvent(e, iter) {
        if (e?.target?.nodeName === "INPUT") {
            e.target.checked = true;
            this.activeOrder = new Order(e.target, this, iter, this.checkout);
            if (this.activeOrder) {
                const elem = [0, 1, 2, 3].map(i => `.rbg-${i}:not(.hidden)`)
                    .find(sel => document.querySelector(sel));
                if (elem) setTimeout(() => this.scrollToElement(elem), 350);
            }
            activeElem = iter;
        }
    }

    registerRbgEvents(cPM) {
        // click events for rbg fieldwraps
        if (cPM) {
            let _t = cPM
            _t.rbgElems.forEach((elem) => {
                elem.addEventListener("click", function (e) {
                    _t.handleRbgEvent(e)
                })
            })
        }
    }

    handleRbgEvent(evt) {
        let _t = this,
            e = evt
        var tgt = e.originalTarget ? e.originalTarget : e.target
        if (tgt.className == "powermail_radio" && tgt.hidden == false) {
            _t.activeOrder.setArticle(tgt)
            _t.removeInvalidAdress()
            // dbg("m radio ", _t.articleRadio);
        }
    }

    /**
     * calculates and returns the type of the clicke dradio button
     * @param {*} e event of radio-click
     * @returns {String} type of radio like "type1" or "type2" - else false if an error occurs
     */
    getTypeOfRadio(e) {
        let type1 = [""],
            type2 = ["#powermail_field_rbg1_2"]
        var id = e != undefined ? "#" + e.id : dbg("ERROR in getType of Radio: ", e, id)

        if (find(id)) {
            if (type1.includes(id)) {
                return "type1"
            } else if (type2.includes(id)) {
                return "type2"
            } else {
                return "type3"
            }
        } else {
            return false
        }
    }

    showControlsForSpecificRadio(type) {
        if (type) {
            let _t = this
            _t.hideOnlyControls()
            switch (type) {
                case "type1":
                    break
                case "type2":
                    // additional information for "ohrmarkennummer" animals
                    _t.showSingleArticleControl(
                        ".powermail_fieldwrap_" + _omnCountryID,
                        "#powermail_field_" + _omnCountryID
                    ) // ohrmarkennummer: land
                    _t.showSingleArticleControl(".powermail_fieldwrap_" + _omnID, "#powermail_field_" + _omnID) // ohrmarkennummer
                    _t.showSingleArticleControl(".powermail_fieldwrap_" + _genderID, "#powermail_field_" + _genderID) // gender select
                    _t.showSingleArticleControl(".powermail_fieldwrap_" + _dateID, "#powermail_field_" + _dateID) // date count
                    break
                default:
                    _t.showSingleArticleControl(".powermail_fieldwrap_" + _selectID, "#powermail_field_" + _selectID) // select count
                    break
            }
            // for all
            _t.showSingleArticleControl(".powermail_fieldwrap_aadress_text", undefined) // aadress Text
            _t.showSingleArticleControl(".powermail_fieldwrap_" + _adressID, "#powermail_field_" + _adressID) // abhol-adress
            _t.showSingleArticleControl(".powermail_fieldwrap_" + _msgID, "#powermail_field_" + _msgID) // nachricht
            _t.showSingleArticleControl(".powermail_fieldwrap_note", undefined) // note (bitte beachten)
        } else {
            //dbg("ERROR: showControlsForSpecificRadio - no type given or undefined", type);
        }
    }

    addNewArticle() {
        debugging ? console.info("article") : undefined
        let _t = this
        _t.addButtons(_t.artSelectButtons, _t)
        _t.registerRbgEvents(_t)
        _t.hideAllArticleControls()

        _t.resetAllArticleInputs() // reset input content on load

        if (_checkoutButton) {
            _t.listenForEventOnCheckoutButton(_t)
        }
    }

    /* GETTER / SETTER START */
    /**
     * gets all article radios with given classes and puts the in an array to return
     * @param {*} radioArray
     * @returns {[]} all article radios in an array
     */
    getAllArticleRadios(radioArray) {
        let rbgClasses
        var returnElems = [],
            iter = 0,
            call = undefined

        radioArray.length >= 1 ? (rbgClasses = radioArray) : (rbgClasses = undefined)

        rbgClasses.forEach((rbg) => {
            var classToSet = "rbg-" + iter
            if (find(rbg)) {
                var elem = find(rbg)
                elem.classList.contains(classToSet) ? "" : elem.classList.add(classToSet)
                elem.classList.contains(this.hideClass) ? "" : elem.classList.add(this.hideClass)
                returnElems.push(elem)
                //dbg("rbg: ", elem);
                ++iter
            }
        })
        returnElems.length === 0 ? (call = false) : (call = returnElems)
        return call
    }

    /**
     * gets all article selects with given classes and puts the in an array to return
     * @returns {[]} all article selects in an array
     */
    getArticleSelect(cls) {
        var className = undefined
        cls ? (className = cls) : undefined
        if (className != undefined) {
            return find(className)
        } else {
            return false
        }
    }

    setRZALink() {
        try {
            let rza = document.querySelector(".powermail_fieldwrap_note .powermail_field p > a");
            if(rza.href == "") {
                rza.href = "https://ztsbetriebe.de/leistungen/"
                rza.target = "_blank"
            }
        } catch (error) {
            // console.error("setRZALink - error: ", error)
        }
    }

    /**
     *
     */
    setUserdataReadonly() {
        // this.setReadonly("#powermail_field_vorname")
        // this.setReadonly("#powermail_field_nachname")
        this.setReadonly("#powermail_field_emailadresse")
    }

    unsetUserdataReadonly() {
        // this.unsetReadonly("#powermail_field_vorname")
        // this.unsetReadonly("#powermail_field_nachname")
        this.unsetReadonly("#powermail_field_emailadresse")
        document.querySelector(".custom-design .btn-primary[data-powermail-morestep-show='2']")
    }

    /**
     *
     * @param {*} selector
     * @returns
     */
    setReadonly(selector) {
        let elem = document.querySelector(selector)
        if (!elem) {
            console.warn("setReadonly: no element found for selector:", selector)
            return
        } else if (elem.value != "" && elem.value != undefined) {
            elem.setAttribute("readonly", "readonly")
            // elem.setAttribute("disabled", "disabled")
            elem.classList.add("readonly")
        } else {
            console.warn("setReadonly: no element found for selector:", selector)
        }
    }

    /**
     *
     * @param {*} selector
     * @returns
     */
    unsetReadonly(selector) {
        let elem = document.querySelector(selector)
        if (!elem) {
            console.warn("unsetReadonly: no element found for selector:", selector)
            return
        } else if (elem.value != "" && elem.value != undefined) {
            elem.removeAttribute("readonly")
            // elem.removeAttribute("disabled")
            elem.classList.remove("readonly")
        } else {
            console.warn("unsetReadonly: no element found for selector:", selector)
        }
    }

    /**
     * adds "checked" to classlist
     * @param {HTMLElement} btn - adds 'checked' here
     */
    setCheckedButton(btn) {
        // console.log("setCheckedButton - btn: ", btn);
        if (btn) {
            // console.log("setCheckedButton - btn.classList: ", btn.classList);
            if (!btn.classList.contains(_checkedClass)) {
                btn.classList.add(_checkedClass)
                // console.log("setCheckedButton - added class: ", _checkedClass, " to button: ", btn);
                this.activeElem = btn
            }
        }
    }

    setOmnMandatories() {
        let omn = find("#powermail_field_omn")

        if (omn && _omnC) {
            let omnParent = omn.parentNode
            if (_omnC.value == "AT" || _omnC.value == "CZ") {
                // console.log(omn.value)
                omn.setAttribute("maxlength", 9)
                omnParent.setAttribute("data-length", 9)
                omn.dataLength = 9

                if (omn.value.length === 10) {
                    omn.value = omn.value.substring(0, 9)
                }
            } else {
                omn.setAttribute("maxlength", 10)
                omnParent.setAttribute("data-length", 10)
                omn.dataLength = 10
            }
        }
    }

    setOmnEvents() {
        if (_omnC) {
            let _t = this
            _omnC.addEventListener("change", function (e) {
                _t.setOmnMandatories()
            })
        }
    }

    setArtBtnClassWatcher() {
        /* init classWatcher */
        let primaryButtonClass = "btn-primary",
            _t = this
        let btn3ClW = new classWatcher(
            _btn3,
            primaryButtonClass,
            function () {
                _btn2.classList.contains(primaryButtonClass) ? undefined : _btn2.classList.add(primaryButtonClass)
                _btn1.classList.contains(primaryButtonClass) ? undefined : _btn1.classList.add(primaryButtonClass)
                // console.log("setArtBtnClassWatcher - btn3 clicked, setting primary class to btn1 and btn2");
                _t.setTextContinueBtn()
            },
            function () {
                _t.setTextContinueBtn()
            }
        )
        let btn2ClW = new classWatcher(
            _btn2,
            primaryButtonClass,
            function () {
                // console.log("setArtBtnClassWatcher - btn2 clicked, setting primary class to btn1");
                // add primary to first button
                _btn1.classList.contains(primaryButtonClass) ? undefined : _btn1.classList.add(primaryButtonClass)
                _t.setTextContinueBtn()
            },
            function () {
                _t.setTextContinueBtn()
            }
        )
    }

    setTextContinueBtn(msg) {
        let button = find(".powermail_fieldset_8 .btn.btn-primary.pull-right")
        if (!msg) {
            if (this.orderArray.length >= 1) {
                button.innerText = "Bereits hinzugefügte Artikel anzeigen"
            } else {
                button.innerText = "Weiter"
            }
        } else if (msg) {
            button.innerText = msg
        }
    }

    setAadressText(text) {
        let comp = document.querySelector(".powermail_fieldwrap_aad_company"),
            _t = this
        if (comp) {
            var txt = document.createElement("p")
            txt.innerText = text
            txt.setAttribute("id", "aadress-text-header")
            txt.setAttribute("class", _t.hideClass)
            comp.before(txt)
        }

        /* highlight new adress text */
        var sepp = findAll(".powermail_fieldwrap_aadress .radio"),
            elem
        if (sepp) {
            elem = sepp[sepp.length - 1]

            // if (!elem.classList.contains("newAdress")) {
            //     elem.classList.add("newAdress");
            // }
        }
    }

    /**
     * sets the link in the aadress text and adds a popup before user gets redirected
     * @returns {boolean} false if aadresstext not found
     */
    setAadressTextLink() {
        let aadresstext = document.querySelector(
            ".powermail_fieldwrap_type_text.powermail_fieldwrap_aadress_text .ce-bodytext"
        )
        if (!aadresstext) {
            console.error("setAadressTextLink - aadresstext not found")
            return false
        }
        let link = aadresstext.querySelector("a[href='/abholadressen-bearbeiten']")
        if (link) {
            link.addEventListener("click", (e) => {
                e.preventDefault()
                let url = link.getAttribute("href")
                Swal.fire({
                    title: "Abholadressen bearbeiten",
                    text: "Durch Kick auf 'Weiter', werden sie zu den Abholadressen weitergeleitet. Anschließend müssen Sie den Anmeldeprozess neu starten.",
                    icon: "info",
                    confirmButtonText: "Weiter",
                    showCancelButton: true,
                    cancelButtonText: "Abbrechen",
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.href = url
                    } else {
                        // console.log("Abbrechen geklickt, keine Weiterleitung.")
                    }
                })
            })
        }
    }
    /* GETTER / SETTER END */

    /* SHOW START */
    /**
     * shows single article-radio element
     * @param {int} iteration - iteration element
     * @returns false, if element is not found
     */
    showArticleRadio(iteration) {
        let elem = find(this.radioClassAdds[iteration])
        if (elem) {
            elem.classList.contains(this.hideClass) ? elem.classList.remove(this.hideClass) : undefined
        } else {
            //dbg("ERROR: showArticleRadio class not found", cls, ' ');
            return false
        }
    }

    /**
     * shows a single article control element with given class and id
     * - usage like: showSingleArticleControl(".powermail_fieldwrap_sfg1","#powermail_fieldwrap_sfg1");
     * @param {*} elemClass class of fieldwrap (ideal the same as id)
     * @param {*} inputId id of fieldwrap (ideal the same as class)
     * @returns
     */
    showSingleArticleControl(elemClass, inputId) {
        let elem = find(elemClass),
            input = find(inputId),
            _t = this
        //dbg("sAS - single article: ." + elemClass + " ", elem, input);
        if (elem) {
            elem.classList.contains(_t.hideClass) ? elem.classList.remove(_t.hideClass) : null
            input.disabled ? (input.disabled = false) : undefined
        } else if (find("." + elemClass) && find("#" + inputId)) {
            var el = find("." + elemClass),
                inp = find("#" + inputId)
            el.classList.contains(_t.hideClass) ? el.classList.remove(_t.hideClass) : null
            inp.disabled ? (inp.disabled = false) : undefined
        } else {
            //dbg("ERROR: showArticleGebDate elem not found", elem);
            return false
        }
        // console.log("showSingleArticleControl - showing elem: ", elemClass, " with input: ", inputId);
    }
    /* SHOW END */

    /* HIDE START */
    /**
     * like the name says: hides all article controls
     */
    hideAllArticleControls() {
        let radios = this.radioClassAdds
        // hide radios
        radios.forEach((rb) => {
            var elem = find(rb)
            if (elem) {
                elem.classList.contains(this.hideClass) ? null : elem.classList.add(this.hideClass)
            } else {
                //dbg("element not found hideAllArticleControls() !", elem);
            }
        })
        // hide all other inputs
        this.hideOnlyControls()
        // this.hideNewAdressFields();
    }

    /**
     * hides all controls, but not the radio buttons
     */
    hideOnlyControls() {
        this.hideSpecificInput(this, _selectID) //select
        this.hideSpecificInput(this, _omnCountryID) //omn-country
        this.hideSpecificInput(this, _omnID) //omn
        this.hideSpecificInput(this, _genderID) //gender
        this.hideSpecificInput(this, _dateID) //date
        this.hideSpecificInput(this, "aadress_text") // aadress text
        this.hideSpecificInput(this, _adressID) //aaddress
        this.hideSpecificInput(this, _msgID) // msg
        this.hideSpecificInput(this, _noteID) // note
        // console.log("hideOnlyControls - hidden all controls except radio buttons");
    }

    // hideNewAdressFields() {
    //     let _t = this,
    //         txt = find("#aadress-text-header");
    //     _adressFields.forEach(field => {
    //         _t.hideSpecificInput(_t, field);
    //     });
    //     if (txt) {
    //         txt.classList.contains(_t.hideClass) ? undefined : txt.classList.add(_t.hideClass);
    //     }
    // }

    /**
     * hides a specific input, with given elem id (from pm)
     * @param {*} _t customPowermail object (this)
     * @param {*} fieldId ID of field - set in powermail (custom var)
     * @returns true if success - else false
     */
    hideSpecificInput(_t, fieldId) {
        var wrap = find(".powermail_fieldwrap_" + fieldId),
            field = find("#powermail_field_" + fieldId)
        if (wrap && field) {
            wrap.classList.contains(_t.hideClass) ? undefined : wrap.classList.add(_t.hideClass)
            field.disabled ? undefined : (field.disabled = true)
            return true
        } else if (wrap && field == false) {
            wrap.classList.contains(_t.hideClass) ? undefined : wrap.classList.add(_t.hideClass)
        } else {
            console.error("hideSpecificInput - value not found: ", fieldId)
            return false
        }
        // console.log("hideSpecificInput - hidden field: ", fieldId, " with wrap: ", wrap);
    }

    /* RESET START */
    /**
     * resets all set displays
     */
    resetButtonDisplay() {
        var elems = findAll("." + _checkedClass)
        elems.forEach((elem) => {
            elem.classList.remove(_checkedClass)
        })
        // console.log("resetButtonDisplay - removed all checked classes from: ", elems);
    }

    resetTextInput(fieldId) {
        if (find("#powermail_field_" + fieldId)) {
            // console.log("resetTextInput - resetting field: ", fieldId);
            var inp = find("#powermail_field_" + fieldId)
            if (inp.value != "") {
                inp.value = ""
            }
        } else {
            console.error("no field found for: ", fieldId)
        }
    }

    resetSelectInput(fieldId) {
        if (find("#powermail_field_" + fieldId)) {
            // console.log("resetSelectInput - resetting field: ", fieldId);
            var select = find("#powermail_field_" + fieldId)
            if (select.childElementCount > 0) {
                select.selectedIndex = 0
            }
        } else {
            console.error("no field found for: ", fieldId)
        }
    }

    /**
     * resets all article radio button inputs to unchecked
     */
    resetAllArticleRadioButtons() {
        var artRadios = findAll(
            ".powermail_fieldwrap_rbg1 .radio input, .powermail_fieldwrap_rbg2 .radio input, .powermail_fieldwrap_rbg3 .radio input, .powermail_fieldwrap_rbg4 .radio input"
        )
        artRadios.forEach((rdo) => {
            if (rdo.checked) {
                rdo.checked = false
            }
        })
        // console.log("resetAllArticleRadioButtons - reset all article radio buttons: ", artRadios);
    }

    /**
     * fires all reset Input functions
     */
    resetAllArticleInputs() {
        // console.log("resetAllArticleInputs - reset all article inputs: ", _selectID, _genderID, _omnID, _dateID, _msgID);
        let _t = this
        _t.resetSelectInput(_selectID)
        _t.resetSelectInput(_genderID)
        _t.resetTextInput(_omnID)
        _t.resetTextInput(_dateID)
        _t.resetTextInput(_msgID)
    }

    resetCategory() {
        let _t = this
        let categoryButtons = findAll(".powermail_fieldwrap_article_select .radio input"),
            artCont = find(".art-cont")
        artCont ? artCont.remove() : ""
        categoryButtons.forEach((btn) => {
            btn.checked ? (btn.checked = false) : undefined
            btn.classList.contains(_checkedClass) ? btn.classList.remove(_checkedClass) : undefined
        })
        _t.resetAllArticleRadioButtons()
        _t.hideAllArticleControls()
        _t.resetAllArticleInputs()
        // console.log("resetCategory - reset all category buttons and article controls");
    }

    resetAdressInputs() {
        let input = findAll(".powermail_fieldwrap_aadress .radio input.powermail_radio")
        if (input.length > 0) {
            input.forEach((inp) => {
                inp.checked == true ? (inp.checked = false) : undefined
            })
        }
    }
    /* RESET END */

    /* helper functions */

    listenForEventOnCheckoutButton() {
        let _t = this
        var tmp = _checkoutButton
        tmp.addEventListener("click", function (e) {
            _t.checkout.handleCheckout(false, _t.checkout)
        })
    }

    enableSubmit() {
        let submit = _submitButton,
            submitError = find("#submit-error")
        if (submit) {
            submit.disabled ? (submit.disabled = false) : undefined
        }
        // hide error text
        if (submitError) {
            submitError.classList.contains("hidden") ? undefined : submitError.classList.add("hidden")
        }
    }

    disableSubmit() {
        let submit = _submitButton,
            submitError = find("#submit-error")

        /* disable button + show error text */
        if (submit) {
            /* create error-field if not found */
            if (!submitError) {
                submitError = document.createElement("p")
                submitError.setAttribute("id", "submit-error")
                submitError.innerText = "Bitte überprüfen Sie Ihre Eingaben! Sie haben keine Artikel gewählt."
                submit.after(submitError)
            }

            submit.disabled = true;
            submitError.classList.contains("hidden") ? submitError.classList.remove("hidden") : undefined
        }
    }

    enableContinue() {
        let cont = find(".powermail_tab_navigation .btn-primary[data-powermail-morestep-show='2']"),
            add = find("#btn-add-and-repeat")
        if (cont) {
            cont.disabled ? (cont.disabled = false) : undefined
            if (add) {
                add.disabled ? (add.disabled = false) : undefined
            }
        }
    }

    disableContinue() {
        let cont = find(".powermail_tab_navigation .btn-primary[data-powermail-morestep-show='2']"),
            add = find("#btn-add-and-repeat")
        if (cont) {
            cont.disabled ? undefined : (cont.disabled = true)
            if (add) {
                add.disabled ? undefined : (add.disabled = true)
            }
        }
    }

    addButtonArticleAddAndRepeat() {
        let _t = this,
            origin = find(".powermail_tab_navigation .btn-warning[data-powermail-morestep-show='0']"),
            portTo = find("#btn-add-and-repeat"),
            check = this.checkout
        var newElem = origin.cloneNode(true)
        newElem.setAttribute("data-powermail-morestep-show", "0")
        newElem.setAttribute("id", "btn-add-and-repeat")
        newElem.disabled = true
        newElem.innerText = _newArticleText
        // click / touch logic
        if (["desktop", "mobile", "tablet"].includes(_t.deviceType)) {
            newElem.addEventListener("click", function (e) {
                // console.log("ADD ARTICLE AND REPEAT!");
                check.handleCheckout(true, _t)
            })
        }
        // append new button only if not added already
        if (!portTo) {
            origin.after(newElem)
        }
    }

    /**
     * removes the button "add and repeat" from the form
     */
    removeButtonArticleAddAndRepeat() {
        let _t = this,
            element = find("#btn-add-and-repeat")
        if (element) {
            element.remove()
        }
    }

    addChangeMailButton() {
        if (find(".user-data")) {
            let mailField = find("#powermail_field_emailadresse")
            var btn = document.createElement("a")
            btn.setAttribute("href", _changeMailLinkSlug)
            btn.setAttribute("class", "btn btn-change-mail")
            btn.setAttribute("id", "btn-change-mail")
            btn.title = "Hier gehts zum Schritt: E-Mail-Adresse"
            btn.setAttribute("aria-label", "Hier gehts zum Schritt: E-Mail-Adresse")
            btn.addEventListener("click", function (e) {
                e.preventDefault()
                Swal.fire({
                    title: "E-Mail ändern",
                    text: "Durch Kick auf 'Weiter' werden Sie auf die Seite der Mail-Anpassung weitergeleitet. Anschließend müssen Sie den Anmeldeprozess neu starten.",
                    icon: "info",
                    confirmButtonText: "Weiter",
                    showCancelButton: true,
                    cancelButtonText: "Abbrechen",
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.href = _changeMailLinkSlug
                    } else {
                        // console.log("Abbrechen geklickt, keine Weiterleitung.");
                    }
                })
            })
            mailField.after(btn)
        }
    }

    listenForAdressChange(aControl) {
        let aadressControl = aControl,
            _t = this
        aadressControl.addEventListener("click", function (e) {
            _t.handleAdressChange(e)
        })
    }

    handleAdressChange(e) {
        /* get clicked target */
        let _t = this,
            target = e.target.nodeName == "INPUT" ? e.target : e.target.querySelector("input")

        if (target) {
            if (this.vStep2 && this.vStep2.validate() === false) {
                // console.warn("handleAdressChange - validation failed ", this.vStep2, target );
                return
            }

            // remove checked elems
            var check = findAll(".powermail_fieldwrap_aadress .radio.cpm-check")
            if (check) {
                check.forEach((che) => {
                    che.classList.remove(_checkedClass)
                })
            }
            // save aadress
            _aAdress = target.value
            // console.log("handleAdressChange - _aAdress: ", _aAdress);

            // add checked class
            var radioParent = target.parentNode.parentNode
            if (radioParent) {
                radioParent.classList.contains(_checkedClass) ? "" : radioParent.classList.add(_checkedClass)
                // check if custom radio
                radioParent.dataset.custom ? _t.enableContinue() : _t.disableContinue()
            } else {
                console.error("no radio parent found in handleAdressChange: ", radioParent)
            }
            if (_aAdress === undefined) {
                console.error("no aadress found in handleAdressChange: ", _aAdress)
            }
        } else {
            console.error("no target found in handleAdressChange: ", e.target)
        }
    }

    removeInvalidAdress() {
        let adressRadios = findAll(".powermail_fieldwrap_aadress .radio")
        if (adressRadios) {
            adressRadios.forEach((radio) => {
                if (!radio.dataset.custom) {
                    radio.remove()
                }
            })
        }
    }

    addToFinal(data) {
        let final = _finalDataField
        if (final && data) {
            final.value += JSON.stringify(decycle(data)) + ";"
            // console.log("addToFinal - final.value: ", final.value);
        }
        this.renderHumanReadable()
    }

    removeFromFinal(ident) {
        if (!ident || Object.keys(ident).length === 0) {
            console.warn("removeFromFinal - no ident provided or empty object: ", ident)
            return false
        }


        let final = _finalDataField
        let finalArray = this.finalData
        var finalInnerText = ""

        /* check validation of elements in finalArray */
        for (let index = 0; index < finalArray.length; index++) {
            const element = finalArray[index]
            this.checkValidationOnCheckout(element)
            // put all elements in data field
            finalInnerText += JSON.stringify(element, null, 0) + ";"
        }

        /* set final value for JSON save */
        if (final && finalInnerText != "") {
            final.value = finalInnerText
            // console.log("renderHumanReadable - rendering final data in human readable format", finalInnerText);
            this.renderHumanReadable()
            return true
        } else {
            console.warn("removeFromFinal - no final ident field found or empty: ", final, ident)
            return false
        }
    }

    /**
     * renders humanReadable tables
     */
    renderHumanReadable() {
        // console.log("renderHumanReadable - rendering human readable data", this.orderArray);
        var data = _finalDataField.value ? _finalDataField.value.split(";").filter(elem => elem !== "").map(elem => JSON.parse(elem)) : [],
            finalHR = _finalDataHumanReadable
        // console.log("renderHumanReadable - finalHR: ", finalHR, " data: ", data)
        if (finalHR && data) {
            var table = document.createElement("table")
            table.setAttribute("class", "final-data-table")
            data.forEach((elem, index) => {
                var heading = document.createElement("tr")
                var head = document.createElement("td")
                head.setAttribute("colspan", "2")
                head.innerText = "Position " + (index + 1)
                heading.appendChild(head)
                table.appendChild(heading)

                var artikel = elem[2],
                    anzahl = elem[3],
                    geschlecht = elem[4] == "-" ? " " : elem[4],
                    geburtsdatum = elem[5] ? elem[5] : " ",
                    ohrmarkennummer = elem[6].length > 2 ? elem[6] : " ",
                    note = elem[7] ? elem[7] : " ",
                    adresse = elem[8] ? elem[8] : " "

                if (artikel && anzahl) {
                    if (artikel != " ") {
                        var artikelnummer = 0;
                        // add article-number
                        if(artikel.split(" [")[1] && artikelnummer == 0) {
                            artikelnummer = artikel.split(" [")[1].replace("]", "");
                            // console.log("Artikelnummer gefunden: ", artikelnummer);
                        }
                        var arow = document.createElement("tr")
                        var ath = document.createElement("th")
                        var atd = document.createElement("td")
                        ath.innerText = "Artikelnummer"
                        atd.innerText = artikelnummer;
                        arow.appendChild(ath)
                        arow.appendChild(atd)
                        table.appendChild(arow)

                        // add articlename without (nr)
                        var row = document.createElement("tr")
                        var th = document.createElement("th")
                        var td = document.createElement("td")
                        th.innerText = "Artikel"
                        td.innerText = artikel.split(" [")[0]
                        row.appendChild(th)
                        row.appendChild(td)
                        table.appendChild(row)
                    }
                    if (anzahl != "" && anzahl >= 1) {
                        var row = document.createElement("tr")
                        var th = document.createElement("th")
                        var td = document.createElement("td")
                        th.innerText = "Anzahl"
                        td.innerText = anzahl
                        row.appendChild(th)
                        row.appendChild(td)
                        table.appendChild(row)
                    }
                    if (geschlecht != " ") {
                        var row = document.createElement("tr")
                        var th = document.createElement("th")
                        var td = document.createElement("td")
                        th.innerText = "Geschlecht"
                        td.innerText = geschlecht
                        row.appendChild(th)
                        row.appendChild(td)
                        table.appendChild(row)
                    }
                    if (ohrmarkennummer != " ") {
                        var row = document.createElement("tr")
                        var th = document.createElement("th")
                        var td = document.createElement("td")
                        th.innerText = "Ohrmarkennummer"
                        td.innerText = ohrmarkennummer
                        row.appendChild(th)
                        row.appendChild(td)
                        table.appendChild(row)
                    }
                    if (geburtsdatum != " ") {
                        var row = document.createElement("tr")
                        var th = document.createElement("th")
                        var td = document.createElement("td")
                        th.innerText = "Geburtsdatum"
                        td.innerText = geburtsdatum
                        row.appendChild(th)
                        row.appendChild(td)
                        table.appendChild(row)
                    }
                    if (adresse) {
                        var row = document.createElement("tr")
                        var th = document.createElement("th")
                        var td = document.createElement("td")
                        var adressenText = adresse
                            .split(",")
                            .map(line => line.trim())
                            .filter(line => line.length > 0)
                            .join("\r\n")
                        th.innerText = "Abholadresse"
                        td.innerText = adressenText
                        row.appendChild(th)
                        row.appendChild(td)
                        table.appendChild(row)
                    }
                    if (note != " ") {
                        var row = document.createElement("tr")
                        var th = document.createElement("th")
                        var td = document.createElement("td")
                        row.classList.add("note")
                        th.innerText = "Notiz"
                        td.innerText = note
                        row.appendChild(th)
                        row.appendChild(td)
                        table.appendChild(row)
                    }
                }

                // if this is the last element, add a final row
                if (index === data.length - 1) {
                    var finalRow = document.createElement("tr")
                    var finalTh = document.createElement("th")
                    finalTh.setAttribute("colspan", "2")
                    finalTh.classList.add("final-row")
                    finalTh.innerText = "ENDE"
                    finalRow.appendChild(finalTh)
                    table.appendChild(finalRow)
                }
            })

            // finalHR.appendChild(table);
            finalHR.value = table.outerHTML // set the innerHTML to the table
            // console.log("renderHumanReadable table ", table.outerHTML);
            // console.log("renderHumanReadable - finalHR: ", finalHR.value);
        } else {
            console.warn("renderHumanReadable - no final data field found or empty: ", finalHR)
        }
    }

    /**
     * removes given article from final data field
     * @param {string} ID - id of the article to remove (e.g. oo-0235673232 - order-id+timestamp)
     * @returns {boolean} true if success - else false
     */
    removeArticleFromFinal(ID) {
        // get data from final field
        // console.log("removeArticleFromFinal - ID: ", ID);
        if (_finalDataField) {
            let orig = this.getDataFromFinal()
            var newData = []
            // console.log("removeArticleFromFinal - original data: ", orig);

            if (orig.length >= 1) {
                orig.forEach((elem) => {
                    if (!elem.includes(ID)) {
                        newData.push(elem)
                        // console.log("removeArticleFromFinal - elem: ", elem, " does not include ID: ", ID);
                    } else {
                        // console.log("removeArticleFromFinal - elem: ", elem, " includes ID: ", ID, " - removing it");
                    }
                })
            }
            newData.length === 0 ? (_finalDataField.innerHTML = "") : (_finalDataField.innerHTML = newData + ";")
            // did it
            if (this.removeArticleFromArray(ID)) {
                this.parseFinal() // parse final data
                this.displayFinalData() // update final data display
                return true
            }
        } else {
            // failed
            console.warn("removeArticleFromFinal - no final data field found: ", _finalDataField)
            return false
        }
    }

    removeArticleFromArray(ID) {
        let idToRemove = ID,
            array = this.orderArray,
            index = array.findIndex((elem) => elem.id === idToRemove)

        // console.log("removeArticleFromArray - trying to remove ID: ", idToRemove, " from array: ", array)
        // console.log("current orderArray: ", this.orderArray)

        if (index > -1) {
            array.splice(index, 1)
            // console.log("removeArticleFromArray - success: ", idToRemove, array)
            this.displayFinalData() // update final data display
            return true
        }

        // if no element found with ID
        // console.error("removeArticleFromArray - no element found with ID: ", idToRemove)
        return false
    }

    getDataFromFinal() {
        var dataObj = []
        if (_finalDataField) {
            let dataString = _finalDataField.innerHTML
            var parts = dataString.split(";")
            parts.forEach((part) => {
                if (part != "") {
                    dataObj.push(part)
                }
            })
        }
        return dataObj
    }

    /**
     * checks validation on checkout finalData - maybe further actions from here
     * @param {Element|null|string} element
     */
    checkValidationOnCheckout(element) {
        if (this.validationOnStep3) {
            // Definition der zu prüfenden Felder mit Index, Feldname und "leerer" Wert
            const checks = [
                {index: 0, type: "error", msg: "no element found in finalData", empty: undefined},
                {index: 1, type: "error", msg: "no element found in finalData", empty: undefined},
                {index: 2, type: "warn", msg: "no articelname element found in finalData", empty: ""},
                {index: 3, type: "warn", msg: "no anzahl element found in finalData", empty: ""},
                {index: 4, type: "warn", msg: "no geschlecht element found in finalData", empty: "-"},
                {index: 5, type: "warn", msg: "no geburtsdatum element found in finalData", empty: ""},
                {index: 6, type: "warn", msg: "no ohrmarkenland element found in finalData", empty: ""},
                {index: 7, type: "warn", msg: "no ohrmarkennummer element found in finalData", empty: ""},
            ]
            for (const check of checks) {
                const value = element[check.index]
                if (value === undefined || value === check.empty) {
                    // console[check.type](`${check.msg} - `, element);
                }
            }
        }
    }

    /* stepChange */
    firstStep() {
        let btn2 = find(".btn-group .btn-default[data-powermail-morestep-current='1']"),
            btn1 = find(".btn-group .btn-default[data-powermail-morestep-current='0']")
        if (btn1 && btn2) {
            btn2.classList.remove("btn-primary")
            btn1.click()
            this.resetCategory()
        }

        // console.log("firstStep - clicked first step button, reset category and step 1");
    }

    /* secondStep without Reset */
    secondStepNoReset() {
        let btn_continue = document.querySelector(".custom-design .btn-primary[data-powermail-morestep-show='1']")
        if (btn_continue) {
            // if continue button is found, click it
            // this.firstStep();
            btn_continue.click()
        }

        // console.log("secondStepNoReset - clicked continue button, no reset category and step 2");
    }

    /* secondStep with Reset */
    secondStep() {
        let btn_continue = document.querySelector(".custom-design .btn-primary[data-powermail-morestep-show='1']")
        if (btn_continue) {
            // if continue button is found, click it
            // this.firstStep();
            this.resetCategory()
            btn_continue.click()
        }

        // console.log("secondStep - clicked continue button, reset category and step 2");
    }

    lastStep() {
        let btn3 = find(".btn-group .btn-default[data-powermail-morestep-current='2']")
        if (btn3) {
            btn3.click()
            this.resetCategory()
        }
    }

    /**
     * scrolls to a specific element
     * - if no element is given, it scrolls to the first h3 in the powermail form
     * @param {string} elem given element selector-string to scroll to
     * @param {boolean} parent  if true, it scrolls to the parent of the element
     */
    scrollToElement(elem, parent) {
        try {
            if (elem) {
                if (parent) {
                    var item = document.querySelector(elem).parentNode
                } else {
                    var item = document.querySelector(elem)
                }
            } else {
                var item = document.querySelector(".tx-powermail.custom-design form > h3")
            }
        } catch (error) {
            // console.log("error in scrollToElement: ", error)
        }

        if (item) {
            item.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
            })
        }
    }
}
